<template>
  <div class="Wallet">
    <div class="Wallet_header">
      <SecondHead class="header_SecondHead"></SecondHead>
    </div>
    <div class="Wallet_main">
      <div class="Wallet_account_my">
        <div class="myBalance">
          <div class="p_line"></div>
          <span class="p_line_span">我的账户</span>
        </div>
        <div class="contentBox">
          <div class="header">
            <div class="title">购买短信</div>
          </div>
          <div class="content">
            <div class="itemBox">
              <div class="label">购买条数：</div>
              <div class="item">
                <el-input-number v-model="messageTotals" controls-position="right" size="small" :min="2"></el-input-number>
                <div style="margin: 0 10px">
                  条 <span style="color: #c1c1c1">(0.1元/条)</span>
                </div>
              </div>
            </div>
            <div class="itemBox">
              <div class="label">实际付款：</div>
              <div style="color: red">{{ money }} 元</div>
            </div>
            <div class="itemBox">
              <div class="label">账号余额：</div>
              <div style="margin-right: 15px">
                {{ DataMoney.usableMoney || 0}} 元
              </div>
              <router-link to="/Mywallet" style="color: #53a4f4"
                >充值</router-link
              >
            </div>
            <div class="btn">
              <el-button :disabled="!DataMoney.usableMoney || 0" size="small" type="primary" @click="recharge"
                >确认购买</el-button
              >
              <!-- <el-button>取消</el-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="支付确认" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <span
        >账户余额为 {{ DataMoney.usableMoney || 0 }} 元，系统将扣除
        {{ money }} 元</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="payment">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="支付提示" :visible.sync="dialogMessage" width="30%" :close-on-click-modal="false">
      <!-- <div class="messageContent">{{ messageContent }}</div> -->
       <el-result v-if="messageState" icon="success" title="支付成功">
      </el-result>
      <el-result v-else icon="warning" title="支付失败">
      </el-result>
    </el-dialog>
  </div>
</template>

<script>
import SecondHead from "@/components/SecondHead";
export default {
  name: "Mywallet",
  components: {
    SecondHead,
  },
  data() {
    return {
      dialogVisible: false,
      dialogMessage: false,
      messageTotals: "",
      messageContent: "",
      messageState: false,
      payMoney: "", //充值账户
      total: 1,
      pageIndex: 1,
      pageSize: 10,
      go: -1,
      activeName: "first",
      DataMoney: {}, //金钱
      input: 0,
    };
  },
  mounted: function () {
    this.queryDownloadRecord();
  },
  computed: {
    money() {
      return this.messageTotals / 10;
    },
  },
  methods: {
    // 确认购买
    recharge(){
        if(this.DataMoney.usableMoney!==0){
            this.dialogVisible = true
        }else{
            this.$message.error('余额不足，请充值！')
        }
    },
    //   购买短信
    payment() {
      let that = this;
      if (that.messageTotals != 0 && that.money >= 0.1) {
        let params = {
          that: this,
          url: `${this.$config.service.purchasesms}`,
          method: "POST",
          data: {
            money: that.money,
            smsNumber: that.messageTotals,
          },
          cb(res) {
            if (res.code == 0) {
              that.DataMoney = res.resultBody;
              that.queryDownloadRecord();
              that.messageContent = res.message;
              that.messageState = true
              that.dialogVisible = false;
              that.dialogMessage = true;
            } else {
              that.messageContent = res.message;
              that.dialogVisible = false;
              that.dialogMessage = true;
              that.messageState = false
            }
          },
        };
        this.$util.request(params);
      } else {
        that.$message.error("请输入需要购买的条数！");
        that.dialogVisible = false;
      }
    },
    open1() {
      const h = this.$createElement;
      this.$notify.info({
        title: "提示",
        message: "该功能暂为开放",
        duration: 2400,
      });
    },

    record() {
      this.$router.push({ path: "/TransactionRecord" });
    },

    queryDownloadRecord() {
      let that = this;
      let params = {
        that: this,
        url: `${this.$config.service.mywallet}`,
        method: "POST",
        cb(res) {
          if (res.code == 0) {
            that.DataMoney = res.resultBody;
            console.log(that.DataMoney);
          }
        },
      };
      this.$util.request(params);
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.Wallet {
  width: 100%;
  min-height: 100%;
  background-color: #f5f5f5;
  .Wallet_header {
    width: 100%;
    height: 68px;
    background-color: #fff;
    .header_SecondHead {
      max-width: 1200px;
      margin: auto;
    }
  }
  .Wallet_main {
    width: 100%;
    height: 100%;
    .Wallet_account_my {
      max-width: 1200px;
      height: 800px;
      margin: 30px auto;
      //
      .myBalance {
        display: flex;
        height: 87px;
        line-height: 87px;
        background-color: #fff;
        .p_line {
          width: 4px;
          height: 20px;
          background: #0080ff;
          margin-right: 15px;
          margin: 34px 15px 0px 34px;
        }
        .p_line_span {
          color: #333;
          fong-size: 16px;
        }
      }
      .myMoney {
        display: flex;
        justify-content: space-around;
        .myMoneyli {
          width: 240px;
          height: 280px;
          border: 1px solid #e1e1e1;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          .lip {
            font-size: 18px;
            color: #333;
          }
          .liMoney {
            height: 25px;
            .mspan {
              font-size: 30px;
            }
            .mspan2 {
              margin-left: 5px;
            }
            //不同金钱的
            .usable {
              color: #f54b4b;
            }
            .expenditure {
              color: #3cc022;
            }
          }
          .lifoot {
            height: 40px;
            line-height: 40px;
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
    .contentBox {
      margin-top: 10px;
      background: #fff;
      .header {
        height: 30px;
        padding: 20px 30px;
        border-bottom: 1px solid #efefef;
        line-height: 30px;
      }
      .content {
        height: 300px;
        padding: 30px;
        .itemBox {
          display: flex;
          align-items: center;
          padding: 15px 0;
          font-size: 14px;
          .label {
            margin-right: 15px;
          }
          .item {
            display: flex;
            align-items: center;
            input {
              width: 60px;
              height: 30px;
              border: 1px solid #ccc;
              //   padding-right: 10px;
              padding-left: 10px;
            }
            input:focus {
              border: 1px solid #ccc;
            }
          }
        }
        .btn {
          padding: 20px 0;
          text-align: center;
        }
      }
    }
  }
}
.messageContent {
  font-size: 18px;
  text-align: center;
  padding-bottom: 20px;
}
</style>
